// @flow strict

export const FirstNameMaxLength = 24;
export const LastNameMaxLength = 24;
export const JobTitleGroupOtherMaxLength = 255;
export const JobTitleOtherMaxLength = 255;
export const EmailMaxLength = 100;
export const PhoneNumberMaxLength = 50;
export const CompanyMaxLength = 255;

export const OTHER_JOB_TITLE_ID: string = '0';
export const OTHER_JOB_TITLE_ID_NUMBER = 0;

export const INVALID_SESSION_ID_STATUS = 4;
export const MAX_WAITING_TIME_IN_SECONDS = 90;
export const CHECKING_STATUS_INTERVAL_TIME_IN_SECONDS = 5;

export const PROFILE_FORM_KEYS = {
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  companyName: 'companyName',
  jobTitleGroup: 'jobTitleGroup',
  jobTitleId: 'jobTitleId',
  jobTitleGroupOther: 'jobTitleGroupOther',
  jobTitleOther: 'jobTitleOther',
  locationId: 'locationId',
  password: 'password',
  isSso: 'isSso',
};
